export default "__VITE_ASSET__DHz38mMo__"